export type NoteTypeEnum = 0 | 1;
export const NoteTypeEnum = {
  Default: 0 as NoteTypeEnum,
  CheckInNote: 1 as NoteTypeEnum,
};

export type NoteStatusEnum = 0 | 1;
export const NoteStatusEnum = {
  Unread: 0 as NoteStatusEnum,
  Read: 1 as NoteStatusEnum,
};

export interface Note {
  id?: string; // System.Guid
  name: string; // string
  text: string; // string
  creatorFullName: string;
  parentId?: string; // System.Guid?
  type: NoteTypeEnum;
  status: NoteStatusEnum;
  companyId?: string; // System.Guid
  creatorId?: string; // System.Guid?
  createdDate: string; // System.DateTime
}

export interface Value {
  value: Note[];
  '@odata.context'?: string | undefined;
  '@odata.count'?: number | undefined;
}

// init api object
function toAPI(data: Partial<Note>): any {
  return {
    Id: data?.id || undefined,
    Name: data?.name || '',
    Text: data?.text || '',
    ParentId: data?.parentId || undefined,
    Type: data?.type || NoteTypeEnum.Default,
    Status: data?.status || 0,
    CompanyId: data?.companyId || undefined,
  };
}

function parse(data?: Partial<Note>): Note {
  const typeKey = data?.type || getNoteTypeText(NoteTypeEnum.Default);
  const statusKey = data?.status || getNoteStatusText(NoteStatusEnum.Unread);

  return {
    id: data?.id || undefined,
    name: data?.name || '',
    text: data?.text || '',
    creatorFullName: data?.creatorFullName || '',
    parentId: data?.parentId || undefined,
    type: NoteTypeEnum[typeKey as keyof typeof NoteTypeEnum],
    status: NoteStatusEnum[statusKey as keyof typeof NoteStatusEnum],
    companyId: data?.companyId || undefined,
    creatorId: data?.creatorId || undefined,
    createdDate: data?.createdDate || '',
  };
}

function getNoteTypeText(type: NoteTypeEnum) {
  return Object.keys(NoteTypeEnum)[
    Object.values(NoteTypeEnum).findIndex((entry) => entry == type)
  ];
}

function getNoteStatusText(status: NoteStatusEnum) {
  return Object.keys(NoteStatusEnum)[
    Object.values(NoteStatusEnum).findIndex((entry) => entry == status)
  ];
}

export default {
  parse,
  toAPI: toAPI,
  getNoteTypeText,
  getNoteStatusText,
};
